import { render, staticRenderFns } from "./CouponManage.vue?vue&type=template&id=c04b6340&scoped=true"
import script from "./CouponManage.vue?vue&type=script&lang=js"
export * from "./CouponManage.vue?vue&type=script&lang=js"
import style0 from "./CouponManage.vue?vue&type=style&index=0&id=c04b6340&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c04b6340",
  null
  
)

export default component.exports